import { useTranslation as useReactTranslation } from 'react-i18next';
export const useTranslation = () => { const { t, i18n } = useReactTranslation(); return { t, changeLanguage: (lng: string) => i18n.changeLanguage(lng), currentLanguage: i18n.language }; };
